function generateId() {
    return Math.random() * 10000;
}

var segmentId = generateId();

export default {
    people: [
        { id: generateId(), active: true,  name: 'Bob',  email: 'bob@bob.com'   },
        { id: generateId(), active: false, name: 'Dan',  email: 'dan@dan.com'   },
        { id: generateId(), active: false, name: 'Barb', email: 'barb@barb.com' , birthday: '1981-10-31' },
        { id: generateId(), active: true,  name: 'Joe',  email: 'joe@joe.com'   },
        { id: generateId(), active: true,  name: 'Sam',  email: 'sam@sam.com'   , birthday: '1973-12-02' },
        { id: generateId(), active: false, name: 'Jan',  email: 'jan@jan.com'   },
        { id: generateId(), active: false, name: 'Rick', email: 'rick@rick.com' },
        { id: generateId(), active: false, name: 'Reg',  email: 'reg@reg.com'   , birthday: '1988-11-21' },
    ],
    segments: [
        { id: segmentId, name: 'Active'  , data: { filters: [{ key: 'Active', matcher: '===', value: 'true' }] }    },
        { id: generateId(), name: 'Inactive', data: { filters: [{ key: 'Active', matcher: '!==', value: 'true' }] }    }
    ],
    funnels: [
        // When should this funnel run?
        //     - Recur on date – Every year on December 25
        //     - Recur on dynamic date – Every year on User's Birthday
        //     - When added to segment
        //     - Randomly every 3 months
        {
            id: generateId(),
            name: 'Newsletter sign up',
            strategy: 'date',
            date: 'birthday',
            segmentIds: [],
            everyone: true,
            steps: [
                {
                    delta: 14,
                    action: 'email',
                    status: 'publish',
                    message: {
                        subject: 'Thanks for signing up!'
                    }
                },
                {
                    action: 'email',
                    status: 'publish',
                    delta: 0,
                    message: {
                        subject: 'Have you ever considered...'
                    }
                },
                {
                    delta: 4,
                    action: 'email',
                    status: 'draft',
                    message: {
                        subject: 'You are not alone!'
                    }
                }
            ]
        },
        {
            id: generateId(),
            name: 'Free Ebook',
            strategy: 'date',
            date: '12-25',
            segmentIds: [segmentId],
            everyone: false,
            steps: [
                {
                    delta: 24,
                    action: 'email',
                    status: 'publish',
                    message: {
                        subject: 'Do you know the difference between...'
                    }
                },
                {
                    delta: 1,
                    action: 'email',
                    status: 'draft',
                    message: {
                        subject: 'What is the first thing that comes to mind?'
                    }
                }
            ]
        },
        {
            id: generateId(),
            name: 'Jobs report',
            strategy: 'date',
            date: '12-25',
            segmentIds: [segmentId],
            everyone: false,
            steps: [
                {
                    delta: 24,
                    action: 'email',
                    status: 'publish',
                    message: {
                        subject: 'Do you know the difference between...'
                    }
                },
                {
                    delta: 1,
                    action: 'email',
                    status: 'draft',
                    message: {
                        subject: 'What is the first thing that comes to mind?'
                    }
                }
            ]
        }
    ],
    columns: [
        { name: 'Name'            , type: 'text'     },
        { name: 'Email'           , type: 'email'    },
        { name: 'Mobile'          , type: 'tel'      },
        { name: 'Address'         , type: 'text'     },
        { name: 'Home Anniversary', type: 'date'     },
        { name: 'Birthday'        , type: 'date'     },
        { name: 'Active'          , type: 'checkbox' },
        { name: 'Unsubscribe'     , type: 'checkbox' },
    ]
};
